/* eslint-disable no-plusplus */
/**
 * Created by ivancai on 2019/5/13.
 * 此工具类请放置一些常用操作函数，如字符操作，存取cookie等
 */
import axios from "axios";
import baseUrl from "@/configs/baseUrl";

export default {
  getCookie(cname) {
    const name = `${cname}=`;
    const ca = document.cookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      const c = ca[i].trim();
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  },
  getQueryString(name) {
    const reg = new RegExp(`(^|&)${name}=([^&]*)(&|$)`);
    const r = window.location.search.substr(1).match(reg);
    if (r != null) return unescape(r[2]);
    return null;
  },
  setCookie(cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    const expires = `expires=${d.toGMTString()}`;
    document.cookie = `${cname}=${cvalue}; ${expires}`;
  },
  downloadFile(url, params = {}, withToken = true, needBaseUrl = true) {
    const token = this.getCookie("X-Access-Token");
    const headers = withToken ? { "X-Access-Token": token } : {};
    url = needBaseUrl ? `${baseUrl}${url}` : url;
    return axios({
      url,
      method: "GET",
      params,
      responseType: "blob",
      headers,
    });
  },
  downloadBlobFile(blob, filename) {
    const objUrl = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    if ("download" in a) {
      document.body.appendChild(a);
      a.style.display = "none";
      a.href = objUrl;
      a.download = filename;
      a.click();
      window.URL.revokeObjectURL(objUrl);
      document.body.removeChild(a);
      return;
    }
    // IE
    navigator.msSaveBlob(blob, filename);
  },
  base64ToBlob(dataurl) {
    const arr = dataurl.split(",");
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], {
      type: mime,
    });
  },
  blobToDataURL(blob, callback) {
    var a = new FileReader();
    a.onload = function (e) {
      callback(e.target.result);
    };
    a.readAsDataURL(blob);
  },
};
